module.exports = __webpack_public_path__ + "img/pic_4.1c0eeade.jpg";